import { NavigationGuard, NavigationGuardNext, Route } from 'vue-router';
import { handlePageNotFound } from '@/common/services/transition-common';
import { PlatformResolutionService } from '@/common/services';

export const checkIfSsoIsAvailable = (): NavigationGuard => {
    return async (_to: Route, _from: Route, next: NavigationGuardNext) => {
        const statelessPlatformService = new PlatformResolutionService();
        const isPageAvailable = !statelessPlatformService.isSsoLoginEnabled();
        if (!isPageAvailable) {
            handlePageNotFound(next);
            return;
        }

        next();
    };
};
